<section class="vehicle__trips">
  <h5 class="text-center">
    {{vehicle?'El vehículo':'El conductor'}} ha realizado un total de
    <i class="fas fa-flag color-secondary-dark"></i>
    <b class="color-secondary-dark">{{numberOfTrips}}
      viajes</b>
  </h5>
</section>